module.exports = __webpack_public_path__ + "img/1.4913ce34.jpg";